import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { is, or } from "@amcharts/amcharts4/core";
import { order } from "@amcharts/amcharts4/.internal/core/utils/Number";

declare var ko: any;

export class ideationWebsiteList_template extends vnTemplate {


    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="list-header w-justify" >

                    <div class="w-left">
                        <button data-bind="click: function() { onClickShowPopUp('add') }" class="btn secondary icon i-add" type="button">Add Website</button>
                    </div>

                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        ${this.pagination.getHtmlBuild()}
                    </div>
                </div>


                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                        ${this.resultInfos.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'url') }, css: { 'list-sort-desc': orderByAndDirection()=='url_DESC', 'list-sort-asc': orderByAndDirection()=='url_ASC' }">Url</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                                <th><span>Delete</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: websites">
                            <tr class="cursor">
                                <td data-bind="event: { click: $parent.onClickEditWebsite }"><a class="right-click"><span data-bind="text: name"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditWebsite }"><a class="right-click"><span data-bind="text: url"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditWebsite }"><a class="right-click"><span data-bind="text: dateCreated"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditWebsite }"><a class="right-click"><span data-bind="text: dateUpdated"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditWebsite } " class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-lightbox light-theme" data-bind="css: { 'is-visible' : isVisible }">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: popupAction() + ' Website'"></h3>
                                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <label class="form-label">Name</label>
                                    <div class="w-input">
                                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: selectedWebsite().name">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Url</label>
                                    <div class="w-input">
                                        <input type="text" name="url" id="url"  class="input-text" data-bind="value: selectedWebsite().url">
                                    </div>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickCancel }" class="btn border only-icon icon">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting website</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to delete this website :

                                        <p data-bind=" if: idWebsiteToDelete() !== null ">
                                        <span data-bind="text: idWebsiteToDelete().name"></span>
                                        </p>

                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>


         `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "ideationWebsiteList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            websites: ko.observableArray([]),
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            isVisible: ko.observable(false),
            showParentName: ko.observable(false),
            popupAction: ko.observable("add"),
            idWebsiteToDelete: ko.observable(null),
            selectedWebsite: ko.observable({
                id: null,
                name: '',
                url: '',
                isDeleted: 0,
                dateCreated: null,
                dateUpdated: null
            }),
            onClickEditWebsite: function (data, event) {
                var website = self.getTemplateViewModel().websites().find(website => website.id === data.id);
                self.getTemplateViewModel().selectedWebsite({
                    ...website,
                    isDeleted: website.isDeleted === true ? 1 : 0
                });
                self.onClickShowPopUp('edit');
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickShowPopUp: function (value, data, event) {
                self.onClickShowPopUp(value)
            },
            onClickShowDeletePopUp: function (value, data, event) {
                self.onClickShowDeletePopUp(value)
            },
             onClickHideDeletePopUp: function (value, data, event) {
                self.onClickHideDeletePopUp()
            },
            onClickCancel: function (value, data, event) {
                self.onClickCancel()
            },
            onClickSave: function (value, data, event) {
                self.onClickSave()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }


    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword(),
            }
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);

        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.websitesListReorder();
    }

    public setWebsites(websites) {

        this.getTemplateViewModel().websites(websites);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowPopUp(action) {
        if (action === 'add') {
            this.getTemplateViewModel().selectedWebsite({
                id: null,
                name: '',
                url: '',
                isDeleted: 0,
                dateCreated: null,
                dateUpdated: null
            });
        }

        this.getTemplateViewModel().popupAction(action);
        this.getTemplateViewModel().isVisible(true);
    }

    public onClickHideDeletePopUp(): any {
        this.getTemplateViewModel().idWebsiteToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    public onClickShowDeletePopUp(data): any {

        this.getTemplateViewModel().idWebsiteToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    public onClickCancel() {
        this.getTemplateViewModel().isVisible(false);
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


    public onClickSave() {

        this.getTemplateViewModel().isVisible(false);
        this.caller.saveWebsite(this.getTemplateViewModel().selectedWebsite());
    }

    public onClickDelete() {
        let website_id = this.getTemplateViewModel().idWebsiteToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteWebsite(website_id);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/ideationWebsiteList_template.ts